import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { date } from '@rxweb/reactive-form-validators';
declare var $: any;

@Component({
  selector: 'app-rainfall',
  templateUrl: './rainfall.component.html',
  styleUrls: ['./rainfall.component.css']
})
export class RainfallComponent implements OnInit {

  lineChartData: ChartDataSets[] = [];
  lineChartLabels: Label[] = [];
  lineChartOptions = {
    responsive: true,
    display: false,

  };
  lineChartColors: Color[] = [
    { borderColor: 'white', backgroundColor: '#d0def9', },
  ];
  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType = 'bar';
  // chart
  userdata: any;
  AddRainDrop: UntypedFormGroup;

  constructor(private spinner: NgxSpinnerService, private auth: Authenticationservice) {
    this.userdata = this.auth.Authention();
    this.AddRainDrop = new UntypedFormGroup({
      rdate: new UntypedFormControl('', Validators.required),
      rcount: new UntypedFormControl('0', Validators.required),
    });
  }

  async ngOnInit(): Promise<void> {
    await this.load_list();
  }
  TH2Local(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  h_url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/`;
  select_list: any = {};
  data_list: any[] = [];
  async load_list() {
    let udata = this.userdata;
    let url = `${this.h_url}function-3/select_sfw_0?f=[dbo].[rainfallStation]&w=status=1`;
    axios.get(url).then(async res => {
      let data0 = res.data.sort((a, b) => a.fmcode - b.fmcode);
      this.data_list = data0;
      this.select_list = data0.filter((el) => el.fmcode == udata.zonedata)[0]
      let list = this.select_list;
      if (!list) { this.select_list = {}; }
      else { await this.Loadraindropbyzone(); }
      //console.log(this.select_list, `\n`, 'data0:', data0)
    }).catch(err => { throw err })
  }

  // โหลดข้อมูลปริมาณน้ำฝนแต่ละโซน 
  zoneraindrop = [];
  @ViewChild('raindrop', { static: false }) raindropTable: any;
  async Loadraindropbyzone() {
    this.zoneraindrop = [];
    let udata = this.select_list;
    let url = `${this.h_url}dbcps/select_s_f_w_0?s=top 400*&f=[dbo].vw_rainfall&w=fmcode='${udata.fmcode}'order by[date]desc`;
    axios.get(url).then(async res => {
      let data0 = res.data.sort((a, b) => b.date_id - a.date_id);
      //console.log('data0', data0);
      data0 = data0.map(item => {
        return { ...item, edit: false, rainfall_edit: item.rainfall };
      });
      this.zoneraindrop = data0;
      let data1 = data0.filter((el) => el.rainfall > 0).slice(0, 30);
      this.lineChartLabels = data1.map((el: any) => { return this.TH2Local(el.date) });
      this.lineChartData = [
        {
          data: data1.map((el: any) => { return el.rainfall }),
          label: `ปริมาณน้ำฝนต่อวัน`,
          datalabels: { color: 'black', align: 'center', offset: 10 }
        }
      ];
      console.log('data1', data1);
    }).catch(err => { throw err })
  }

  // เพิ่มปริมาณน้ำฝนรายวัน
  UpdateRaindrop() {
    let rd = this.AddRainDrop.get('rcount').value;
    let rdate = this.AddRainDrop.get('rdate').value;
    let iddata = this.zoneraindrop.filter((el: any) => el.date.slice(0, 10) === rdate);
    if (iddata.length == 0 || iddata == undefined) {
      alert('วันที่เกินจาก วันที่ ปัจจุบันค่ะ');
    }
    else {
      let url = `${this.h_url}dbcps/update_rainfall_w?date_id=` + iddata[0].date_id + `&rainfall=` + rd;
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert('!!!บันทึกข้อมูลสำเร็จ!!!!');
          $("#Raindrop").modal('hide');
          this.Loadraindropbyzone();
          this.AddRainDrop.reset();
          iddata = [];
        }
        else {
          alert('!!!บันทึกข้อมูลไม่สำเร็จ!!!!');
        }
      });
    }
  }

  UpdateRaindrop2(item: any) {
    let user = this.userdata;
    if (confirm(`ต้องการบันทึกข้อมูล ?  ${item.fmcode}-${item.fmname} \n วันที่ ${this.TH2Local(item.date)} ปริมาณน้ำฝน ${item.rainfall_edit}`) == true) {
      let url = `${this.h_url}dbcps/update_rainfall_w?date_id=${item.date_id}&rainfall=${item.rainfall_edit}&user_update=${user.supcode}`;
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] >= 1) {
          alert('!!!บันทึกข้อมูลสำเร็จ!!!!');
          this.Loadraindropbyzone();
        }
        else {
          alert('!!!บันทึกข้อมูลไม่สำเร็จ!!!!');
        }
      });
    }
  }

  OpenModal() {
    $("#Raindrop").modal('show');
  }

  // ปิดโมเดล
  ChoseModal() {
    $("#Raindrop").modal('hide');
    this.AddRainDrop.reset();
  }

}
